import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clock, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { Seo, breadcrumbJsonLd } from "@/components/Seo";

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" }) : "");

export const BlogCard = ({ post, big = false }) => (
  <Link to={`/blog/${post.slug}`} className="group block border border-white/10 bg-[#111] hover:border-[#D4AF37]/60 transition-colors" data-testid={`blog-card-${post.slug}`}>
    <div className={`overflow-hidden ${big ? "aspect-[16/8]" : "aspect-[16/9]"} bg-[#1a1a1a]`}>
      {post.cover_image && <img src={post.cover_image} alt={post.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />}
    </div>
    <div className="p-5">
      <div className="flex items-center gap-3 text-[10px] font-overline text-neutral-500 mb-2">
        <span className="text-[#D4AF37]">{post.category}</span>
        <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {post.reading_minutes} min</span>
      </div>
      <h3 className={`font-display font-bold leading-tight group-hover:text-[#D4AF37] transition-colors ${big ? "text-2xl md:text-3xl" : "text-lg"}`}>{post.title}</h3>
      <p className="text-sm text-neutral-400 mt-2 line-clamp-3">{post.excerpt}</p>
      <div className="mt-4 font-overline text-[10px] text-[#D4AF37] flex items-center gap-1">LEGGI <ArrowRight className="w-3 h-3" /></div>
    </div>
  </Link>
);

export default function Blog() {
  const [posts, setPosts] = useState(null);
  const [cat, setCat] = useState("all");
  useEffect(() => { api.get("/blog").then(({ data }) => setPosts(data)).catch(() => setPosts([])); }, []);

  const cats = ["all", ...Array.from(new Set((posts || []).map((p) => p.category)))];
  const shown = (posts || []).filter((p) => cat === "all" || p.category === cat);
  const [first, ...rest] = shown;

  return (
    <div className="bg-[#0A0A0A] min-h-screen text-white">
      <Seo id="blog" title="Consigli e guide sugli integratori" description="Guide pratiche su whey, creatina, pre-workout, barrette proteiche e definizione. I consigli degli esperti Power Fitness Nutrition per scegliere gli integratori giusti." jsonLd={breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Consigli", path: "/blog" }])} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-14" data-testid="blog-page">
        <div className="font-overline text-xs text-[#D4AF37] mb-3">— IL BLOG DI POWER FITNESS NUTRITION</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-none mb-4">CONSIGLI & GUIDE</h1>
        <p className="text-neutral-400 max-w-2xl mb-8 text-sm sm:text-base">Come scegliere le whey, quando prendere la creatina, quale pre-workout fa per te: guide oneste scritte da chi gli integratori li vende e li usa ogni giorno.</p>
        {cats.length > 2 && (
          <div className="flex flex-wrap gap-2 mb-10">
            {cats.map((c) => <button key={c} onClick={() => setCat(c)} className={`px-3 py-1.5 text-[10px] font-overline border ${cat === c ? "border-[#D4AF37] text-[#D4AF37]" : "border-white/15 text-neutral-400 hover:text-white"}`} data-testid={`blog-filter-${c}`}>{c === "all" ? "Tutti" : c}</button>)}
          </div>
        )}
        {posts === null ? <div className="text-sm text-neutral-500">Caricamento...</div>
          : shown.length === 0 ? <div className="text-sm text-neutral-500" data-testid="blog-empty">Nessun articolo pubblicato.</div>
          : (
            <div className="space-y-8">
              <BlogCard post={first} big />
              {rest.length > 0 && <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">{rest.map((p) => <BlogCard key={p.slug} post={p} />)}</div>}
            </div>
          )}
      </div>
    </div>
  );
}
